import Swiper, {Navigation, Autoplay, EffectFade} from "swiper";

export default (el) => {
  const swiperEl = el.querySelector('.js-p-component-slider')

  new Swiper(swiperEl, {
    modules: [Navigation, Autoplay, EffectFade],
    loop: true,
    speed: 1000,
    effect: 'fade',
    autoplay: {
      delay: 6500,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
}
